import React, {useState} from 'react'
import { FaTwitter, FaLinkedin, FaGithub } from 'react-icons/fa';
import { useForm } from "react-hook-form";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  function encode(data) {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  }


  const { register, formState: { errors }, handleSubmit } = useForm();
  function onSubmit() {
    // e.preventDefault();
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", name, email, message }),
    })
  
      .then((data) => console.log(data))
      .catch((error) => alert(error));
  }


  return (
    <section id="contact" className="relative">
         <h1 className="sm:text-4xl text-3xl text-center font-medium title-font text-white mb-4">
         Get In Touch
        </h1>
    <div className="container px-5 py-4 mx-auto flex sm:flex-nowrap flex-wrap">
      <div className="lg:w-1/2 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden  p-10 flex justify-start relative">
        <div className="bg-gray-900 relative flex flex-wrap py-6 rounded shadow-md">
          <div className="lg:w-1/2 px-6">
            <h2 className="title-font font-semibold text-white text-center tracking-widest text-xs">
              SOCIAL LINKS
            </h2>
            <div className='flex'>
              <a href="https://twitter.com/TheDevPhilip">
                <FaTwitter className="w-8 h-6 m-5 text-blue-600"  />
              </a>
              <a href="https://linkedin.com/in/iamphilipifeanyi">
                <FaLinkedin className="w-8 h-6 m-5 text-indigo-900"  />
              </a>
              <a href="https://github.com/Philipdeve">
                <FaGithub className="w-8 h-6 m-5"  />
              </a>

            </div>
          
          </div>
          <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
            <h2 className="title-font font-semibold text-white tracking-widest text-xs">
              EMAIL
            </h2>
            <a href="mailto:thedeveloperphilip@gmail.com" className="text-indigo-400 leading-relaxed">
              thedeveloperphilip@gmail.com
            </a>
            <h2 className="title-font font-semibold text-white tracking-widest text-xs mt-4">
              PHONE
            </h2>
            <p className="leading-relaxed">+234-812-8255-350</p>
          </div>
        </div>
      </div>
      <form
        netlify
        name="contact" onSubmit={handleSubmit(onSubmit)}
        className="lg:w-1/2 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
        <h2 className="text-white sm:text-4xl text-3xl mb-1 font-medium title-font">
          Hire Me
        </h2>
       
        <div className="relative mb-4">
          <label htmlFor="name" className="leading-7 text-sm text-gray-400">
            Name
          </label>
          <input
              {...register("Name", { required: true })} 
               aria-invalid={errors.Name ? "true" : "false"} 
            type="text"
            // id="name" name="name"  
            onChange={(e) => setName(e.target.value)}
            className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
          />
            {errors.Name?.type === 'required' && <p role="alert">Name is required</p>}
        </div>
        <div className="relative mb-4">
          <label htmlFor="email" className="leading-7 text-sm text-gray-400">
            Email
          </label>
          <input
            {...register("mail", { required: "Email Address is required" })} 
            aria-invalid={errors.mail ? "true" : "false"} 
            type="email"
            // id="email" // name="email" 
             onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
          />
          {errors.mail && <p role="alert">{errors.mail?.message}</p>}
        </div>
        <div className="relative mb-4">
          <label
            htmlFor="message"
            className="leading-7 text-sm text-gray-400">
            Message
          </label>
          <textarea
            // id="message" name="message"  
            {...register("msg", { required: "Message Field required" })} 
            aria-invalid={errors.msg ? "true" : "false"} 
            onChange={(e) => setMessage(e.target.value)}
            className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
          />
             {errors.msg && <p role="alert">{errors.msg?.message}</p>}
        </div>
        <button
          type="submit"
          className="text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">
          Submit
        </button>
      </form>
    </div>
  </section>
  )
}

export default Contact